module.exports = __webpack_public_path__ + "static/main-background-044779e8365153255f7f831e4c6ac795.png";